import { tutorialHandler } from "./tutorial";
import '../css/tailwind.css';


document.addEventListener("DOMContentLoaded", () => {
  /**
   * Main nav
   */
  const mainNav = document.querySelectorAll("#main-nav");
  if (mainNav.length > 0) {
    import("./nav").then((module) => {
      module.navHandler();
    });
  }

  /**
   * User menu
   */
  const userMenu = document.querySelectorAll("#user-menu");
  if (userMenu.length > 0) {
    import("./user-menu").then((module) => {
      module.userMenuHandler();
    });
  }

  /**
   * Image loader
   */
  const imageLoader = document.querySelectorAll("#image-loader");
  if (imageLoader.length > 0) {
    import("./image-loader").then((module) => {
      module.imageLoaderHandler();
    });
  }

  /**
   * Image loader
   */
  const bulkImageLoader = document.querySelectorAll("#bulk-image-loader");
  if (bulkImageLoader.length > 0) {
    import("./bulk-image-loader").then((module) => {
      module.imageLoaderHandler();
    });
  }

  /**
   * Accordions
   */
  const accordions = document.querySelectorAll(".accordion");
  if (accordions.length > 0) {
    import("./accordion").then((module) => {
      module.accordionHandler();
    });
  }

  /**
   * New Order
   */
  const new_order = document.querySelectorAll("#new_order");
  if (new_order.length > 0) {
    import("./new_order").then((module) => {
      module.categoryHandler();
      module.orderParse();
    });
  }

  /**
   * Users search box
   */
  const usersSearchBox = document.querySelectorAll("#usersSearch");
  if (usersSearchBox.length > 0) {
    import("./search-bars").then((module) => {
      module.usersSearchHandler();
    })
  }

  /**
   * Products search box
   */
  const productsSearchBox = document.querySelectorAll("#productSearch");
  if (productsSearchBox.length > 0) {
    import("./search-bars").then((module) => {
      module.productsSearchHandler();
    })
  }

  /**
   * Orders search box
   */
  const ordersSearchBox = document.querySelectorAll("#ordersSearch");
  if (ordersSearchBox.length > 0) {
    import("./search-bars").then((module) => {
      module.ordersSearchHandler();
    })
  }

  /**
   * Login form password padding
   */
  const formLogin = document.querySelector("#formLogin");

  if (formLogin !== null) {
    import("./password").then((module) => {
      module.passwordHandler(formLogin);
    })
  }

  tutorialHandler();
});



